import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';

import { registrarTroca } from './inventarioActions';
import LabelAndInput from '../../common/form/labelAndInput';
import LabelAndSelectForm from '../../common/form/labelAndSelectForm';
import Grid from '../../common/layout/grid';
import Button from '../../common/form/button';

const renderTextarea = field => (
  <Grid cols={field.cols}>
    <div className="form-group form-group-sm">
      <label className="label-gt" htmlFor={field.name}>
        {field.label}
      </label>
      <textarea {...field.input} className="form-control" rows={field.rows || 2} style={{ resize: 'vertical' }} />
    </div>
  </Grid>
);

class InventarioTrocarForm extends Component {
  handleSubmit = values => {
    const { selected } = this.props;
    if (!selected || !selected.id) return;
    this.props.registrarTroca(selected.id, {
      equipamento_tipo_id: values.novo_equipamento_tipo_id
        ? parseInt(values.novo_equipamento_tipo_id, 10)
        : undefined,
      fabricante: values.novo_fabricante,
      modelo: values.novo_modelo,
      numero_serie: values.novo_numero_serie,
      data_instalacao: values.data_instalacao,
      data_garantia_fim: values.nova_data_garantia_fim,
      ordem_servico_id: values.ordem_servico_id ? parseInt(values.ordem_servico_id, 10) : null,
      motivo: values.motivo,
      observacao: values.nova_observacao,
    });
  };

  render() {
    const { handleSubmit, selected, opcoes } = this.props;
    if (!selected) {
      return (
        <div className="manutencao-premium-list manutencao-cad-hint">
          Selecione um equipamento na lista e use &quot;Trocar&quot; para registrar substituição.
        </div>
      );
    }

    const tipos = opcoes.tipos || [];

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)} className="simple-cad-form-premium manutencao-cad-premium">
        <div className="simple-cad-premium-container">
          <div className="simple-cad-premium-card">
            <div className="simple-cad-premium-header">
              <h4>
                <i className="fa fa-exchange-alt" /> Trocar equipamento #{selected.id}
              </h4>
              <p>
                O equipamento atual será marcado como removido e um novo será cadastrado como instalado.
              </p>
            </div>
            <div className="simple-cad-premium-body">
              <div className="manutencao-cad-hint cols-12" style={{ marginBottom: 12 }}>
                Atual: <strong>{selected.tipo_nome}</strong>
                {selected.etiqueta ? ` — ${selected.etiqueta}` : ''} em {selected.cruzamento}
              </div>

              <Field name="motivo" component={LabelAndInput} label="Motivo da troca" cols="12 6" />
              <Field name="ordem_servico_id" component={LabelAndSelectForm} label="OS relacionada" cols="12 3">
                <option value="">Nenhuma</option>
                {(opcoes.ordens_abertas || []).map(os => (
                  <option key={os.id} value={String(os.id)}>
                    {os.numero}
                  </option>
                ))}
              </Field>
              <Field name="data_instalacao" component={LabelAndInput} type="date" label="Data da troca" cols="12 3" />

              <Field name="novo_equipamento_tipo_id" component={LabelAndSelectForm} label="Tipo do novo" cols="12 4">
                <option value="">Mesmo tipo</option>
                {tipos.map(t => (
                  <option key={t.id} value={String(t.id)}>
                    {t.nome}
                  </option>
                ))}
              </Field>
              <Field name="novo_fabricante" component={LabelAndInput} label="Fabricante (novo)" cols="12 4" />
              <Field name="novo_modelo" component={LabelAndInput} label="Modelo (novo)" cols="12 4" />
              <Field name="novo_numero_serie" component={LabelAndInput} label="Nº série (novo)" cols="12 4" />
              <Field name="nova_data_garantia_fim" component={LabelAndInput} type="date" label="Garantia até" cols="12 4" />
              <Field name="nova_observacao" component={renderTextarea} label="Observações" cols="12 12" rows="2" />
            </div>
          </div>
        </div>
        <div className="simple-cad-premium-footer">
          <Button type="submit" className="warning" icon="exchange-alt" label="Confirmar troca" />
        </div>
      </form>
    );
  }
}

InventarioTrocarForm = reduxForm({
  form: 'inventarioTrocarForm',
  destroyOnUnmount: false,
  initialValues: { motivo: 'Troca em campo' },
})(InventarioTrocarForm);

const mapStateToProps = state => ({
  selected: state.manutencaoInventario.selected,
  opcoes: state.manutencaoInventario.opcoes,
});

const mapDispatchToProps = dispatch => bindActionCreators({ registrarTroca }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InventarioTrocarForm);
